import { IFormState } from '../types/calculator';
import { EObjectType, ERealEstateType } from '../types/calculator/enums';

export const calculateValueFromPercentage = (oneHundredPercent: number, percent: number): number => {
  return Math.ceil((oneHundredPercent / 100) * percent);
};

export const calculatePercentage = (total: number, value: number) => {
  return (Number(value) / Number(total)) * 100;
};

export const isNewBuilding = (state: IFormState) => state.realEstateType === ERealEstateType.NewBuilding;
export const isSecondary = (state: IFormState) => state.realEstateType === ERealEstateType.Secondary;
export const isHouseBuilding = (state: IFormState) => state.realEstateType === ERealEstateType.HouseBuilding;

export const isApartments = ({ objectType }: IFormState) => objectType === EObjectType.Apartments;

export const isFlatOrUnselected = ({ objectType }: IFormState) =>
  objectType === EObjectType.Flat || objectType === undefined;
